import { Navbar } from 'reactstrap';
import styled from 'styled-components';

export const DashboardNavbar = styled(Navbar).attrs({
  color: 'faded',
  dark: true,
  fixed: 'top',
  expand: true,
  id: 'navbar'
})`
  background-color: ${({ backgroundcolor }) => backgroundcolor};
  text-align: left;
  height: 55px;
`;



// WEBPACK FOOTER //
// ./src/components/common/Navigation/Navigation.style.js